import React, { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { AccountDetailsBody, DetailsTabs } from './physicianDetails.styled';
import PhysicianDetailTabListContainer from './physicianDetailTabListContainer';
import PhysicianDetailCard from './physicianDetailCard';
import PhysicianHeader from './physicianHeader';
import { physicianDetailsTabs } from './physicianListConstants';
import AccountNotes from 'src/pages/more/pages/physicians/components/physicianDetails/physicianNotes/index.jsx';
import AssociatedAccountsDesktop from 'src/pages/more/pages/physicians/components/physicianDetails/associatedAccount.jsx';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import UnsavedChanges from 'src/pages/scheduleSurgery/components/surgery/notifications/UnsavedChanges';
import {
    setUnsavedChangePhysician,
    setShowUnsavedPhysician,
    setPhysicianDetailTabAction,
    showAccountDetails,
    closePhysicianPopUP,
    setTemplateNoteChangePhysician,
    setTemplateNote,
} from 'src/pages/more/redux/actions';
import { useTranslation } from 'react-i18next';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const PhysicianDetails = forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [, setAccountTabActiveId] = useState(null);
    const [saved, setSaved] = useState(false);

    const { accounts } = useSelector(
        (state) => state.loginReducer.moreVisibility
    );

    const { selectedTabId, tabLists } = useSelector(
        (state) => state.accountReducer
    );
    const commonUnsavedchanges = useSelector(
        (state) => state.accountReducer.commonUnsavedchangesPhysician
    );
    const physicianDet = useSelector(
        (state) => state.accountReducer.physicianDetails.physicianDetails
    );
    const physicianNotes = useSelector(
        (state) => state.accountReducer.physicianDetails.notes
    );
    const associatedAccounts = useSelector(
        (state) => state.accountReducer.physicianDetails.associatedAccounts
    );
    const loading = useSelector(
        (state) => state.accountReducer.physicianDetailLoading
    );

    const showUnsaved = useSelector(
        (state) => state.accountReducer.showUnsavedPhysician
    );
    const onTabSwitchHandler = (Id) => {
        setAccountTabActiveId(Id);

        dispatch(setPhysicianDetailTabAction({ selectedTabId: Id }));
    };
    useEffectWithErrorLogging(() => {
        const tabListsDetails = physicianDetailsTabs()?.filter(
            (x) => tabLists?.findIndex((tabList) => tabList === x.id) != -1
        );
        if (tabListsDetails?.length > 0) {
            // setOrderDetailTabs(tabListsDetails);
            setAccountTabActiveId(selectedTabId);
        }
    }, [tabLists]);
    const handleDiscardChanges = () => {
        physicianNotes
            ? dispatch(setTemplateNote(physicianNotes))
            : dispatch(setTemplateNote(''));
        dispatch(setUnsavedChangePhysician(false));
        dispatch(setShowUnsavedPhysician(false));
        dispatch(showAccountDetails(false));
        setAccountTabActiveId('physicianDetails');
        dispatch(setTemplateNoteChangePhysician(false));
        dispatch(
            setPhysicianDetailTabAction({ selectedTabId: 'physicianDetails' })
        );

        if (props.isFromAdmin) {
            props.setShowPopup(false);
        }
    };
    const closeAccountDetails = () => {
        // dispatch(clearPhysicianDetails());

        if (commonUnsavedchanges) {
            dispatch(setShowUnsavedPhysician(true));
        } else {
            dispatch(showAccountDetails(false));
            dispatch(closePhysicianPopUP(true));
            if (props.isFromAdmin) {
                props.setShowPopup(false);
            }
        }
    };
    // ...existing code...

    // Expose closeAccountDetails via imperative handle
    useImperativeHandle(ref, () => ({
        handleClose : () => {
            if(props.isFromAdmin){
                closeAccountDetails();
            } else {
                props.handleClose();
            }            
        }
    }), []);

    const handleSaveAndExit = () => {
        dispatch(setShowUnsavedPhysician(false));
        dispatch(setUnsavedChangePhysician(true));
    };
    const fromSettingsClose = () => {
        dispatch(setShowUnsavedPhysician(false));
        dispatch(setUnsavedChangePhysician(true));
    };

    return (
        <>
            {loading === false && (
                <AccountDetailsBody>
                    <PhysicianHeader
                        isFromAccount={props.isFromAccount}
                        account={props.accountDetail}
                        onClose={
                            props.isFromAdmin
                                ? closeAccountDetails
                                : props.handleClose
                        }
                        fromSearch={props.fromSearch}
                        employeeRole={props.employeeRole}
                        setShowPopup={props.setShowPopup}
                        isFromAdmin={props.isFromAdmin}
                    />

                    {/* <AccountDetailsTabs/> */}
                    <DetailsTabs>
                        <PhysicianDetailTabListContainer
                            accountDetailTabList={physicianDetailsTabs().filter(
                                (tab) =>
                                    tab.id === 'associatedAccounts'
                                        ? accounts
                                        : true
                            )}
                            tabActiveId={selectedTabId}
                            tabSwitch={onTabSwitchHandler}
                        />
                    </DetailsTabs>

                    {selectedTabId === 'physicianDetails' && (
                        <PhysicianDetailCard account={physicianDet} />
                    )}

                    {
                        selectedTabId === 'associatedAccounts' && (
                            // (window.innerWidth <= sizes.mobileDevice ? (
                            //     <AssociatedAccountBodyContainer>
                            //         <AssociatedAccounts
                            //             accountData={accountData}
                            //             isFromPhysician={true}
                            //         />
                            //     </AssociatedAccountBodyContainer>
                            // ) : (
                            <AssociatedAccountsDesktop
                                accountData={associatedAccounts}
                                isFromPhysician={true}
                                employeeRole={props.employeeRole}
                            />
                        )
                        // ))}
                    }

                    {selectedTabId === 'notes' && (
                        <AccountNotes
                            fromPhysician={true}
                            physician={props.accountDetail}
                            physicianNotes={physicianNotes}
                            saved={saved}
                            setSaved={setSaved}
                            employeeRole={props.employeeRole}
                        />
                    )}
                    {showUnsaved && commonUnsavedchanges && !saved ? (
                        <UnsavedChanges
                            onDiscard={handleDiscardChanges}
                            onClose={handleSaveAndExit}
                            continueText={t('more.common.conedit')}
                            fromSettingsClose={fromSettingsClose}
                        />
                    ) : null}
                </AccountDetailsBody>
            )}
            {loading === true && (
                // <Spinner animation="border" variant="primary"></Spinner>
                <Spinner id="more-physicianDetails-physicianDetails-loadingSpinner" animation="border" variant="primary" small></Spinner>
            )}
        </>
    );
});

export default PhysicianDetails;
